module.exports = __webpack_public_path__ + "static/media/portrait-patrickvoegeli.44ac30b4.jpg";